/**
 * Creates a `Deferred` object that provides a new promise along with methods to
 * change its state.
 * @template T
 * @returns {Deferred.<T>}
 */
export default function createDeferred() {
    var reject;
    var resolve;
    return {
        promise: new Promise(function (_resolve, _reject) {
            reject = _reject;
            resolve = _resolve;
        }),
        // reject was assigned, because Promise initialization is eager (sync).
        // @ts-expect-error
        reject: reject,
        // resolve was assigned, because Promise initialization is eager (sync).
        // @ts-expect-error
        resolve: resolve,
    };
}
//# sourceMappingURL=main.js.map